import { useGlobal } from "kanopi-components/useGlobal";

/**
 * Test if the current user is authenticated.
 *
 * Returns false for lazy users.
 */
export function useIsLoggedIn() {
  const [auth] = useGlobal("auth");
  return auth?.user?.isLazy === false;
}
